<template lang="html">
  <div class="gmap-checkable form-row align-items-center mb-3">
    <div v-if="label" class="col-12">
      <label class="font-weight-bold">{{ label }}</label>
    </div>
    <div :class="noCheckbox ? 'col-12 pr-0' : 'col-11 pr-0'">
      <input
        v-if="value"
        @blur="$emit('blur')"
        @focus="handleFocus"
        @change="validate"
        :pattern="pattern"
        :disabled="textDisabled"
        type="text"
        class="form-control"
        v-model="ivalue">
      <gmap-autocomplete
        v-else
        :id="gMapId"
        ref="gmap"
        onclick="this.select()"
        @focus="handleGMapFocus"
        @blur="$emit('blur')"
        @place_changed="loc => { $emit('textChanged', loc) }"
        :options="{fields: ['geometry', 'name', 'formatted_address', 'vicinity']}"
        :componentRestrictions="{ country: ['ar'] }"
        :types="[placesTypes]"
        type="text"
        :placeholder="placeholderLabel"
        class="form-control">
      </gmap-autocomplete>
    </div>
    <div class="col-1 px-1" v-if="!noCheckbox" style="text-align: end;">
      <InlineCheck
        @checkChanged="$emit('checkChanged')"
        :isChecked="isChecked"
        :checkDisabled="checkDisabled" />
    </div>
    <div v-if="errors" class="col-12">
      <small class="text-danger">
        {{ errorMessage }}
      </small>
    </div>
  </div>
</template>

<script>
import InlineCheck from './InlineCheck'

export default {
  components: {
    InlineCheck
  },

  props: {
    label: String,
    isChecked: Boolean,
    value: String,
    pattern: String,
    errorMessage: String,
    checkDisabled: Boolean,
    textDisabled: Boolean,
    type: String,
    noCheckbox: Boolean,
    placesTypes: String,
    gMapId: String
  },

  data: () => ({
    errors: false,
    ivalue: ''
  }),

  computed: {
    placeholderLabel () {
      if (this.placesTypes === 'address')
        return 'Ingresá una dirección exacta'
      else if (this.placesTypes === '(cities)')
        return 'Ingresá una localidad'
      else
        return 'Ingresá una ubicación'
    }
  },

  watch: {
    value (value) { this.ivalue = value }
  },

  methods: {
    validate (e) {
      const value = this.ivalue

      if (this.pattern) {
        const re = new RegExp(this.pattern)
        if (!value.match(re)) {
          this.errors = true
          e.target.classList.add('is-invalid')

          return
        }
      }

      this.$emit('textChanged', value)
    },

    handleFocus (e) {
      this.$emit('focus')
      if (this.errors) {
        this.errors = false
        e.target.classList.remove('is-invalid')
      }
    },

    handleGMapFocus () {
      const mapsAutocomplete = document.getElementById(this.gMapId)
      mapsAutocomplete && mapsAutocomplete.setAttribute('autocomplete', 'chrome-off')
      this.$emit('focus')
    }
  },

  mounted () {
    this.ivalue = this.value
  }
}
</script>

<style lang="scss">
  @import '../../../scss/colors';

  .gmap-checkable {
    label {
      color: $dark;
      font-weight: 500;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ui/forms/GmapCheckable.vue